module.exports = __webpack_public_path__ + "img/40.a507119e.svg";